/** Adult best-of pages taken offline on October 28, 2026. They return 410 and must not be linked. */
export const REMOVED_BESTICLE_SLUGS = [
  'best-nude-ai-chat-platforms',
  'best-nsfw-character-ai-alternatives',
  'best-erotic-ai-chat-platforms',
  'best-ai-sex-story-generator-platforms',
  'best-ai-roleplay-chat-platforms',
  'best-dirty-talking-ai-chat-platforms',
] as const;

export const REMOVED_BESTICLE_PATHS = REMOVED_BESTICLE_SLUGS.map((slug) => `/best/${slug}`);

const SLUG_PATTERN = REMOVED_BESTICLE_SLUGS.join('|');

export function isRemovedBesticleSlug(slug: string): boolean {
  return (REMOVED_BESTICLE_SLUGS as readonly string[]).includes(slug);
}

/** Drop links to removed best-of pages. The visible words stay. */
export function stripRemovedBesticleLinks(text: string): string {
  if (!text || !SLUG_PATTERN) return text;
  const html = new RegExp(
    `<a\\b[^>]*href=["'][^"']*(?:${SLUG_PATTERN})[^"']*["'][^>]*>([\\s\\S]*?)<\\/a>`,
    'gi',
  );
  const markdown = new RegExp(
    `\\[([^\\]]+)\\]\\([^)]*(?:${SLUG_PATTERN})[^)]*\\)`,
    'gi',
  );
  return text.replace(html, '$1').replace(markdown, '$1');
}
